import { getPathnameItem } from "helpers/inventory-filters";
import upperCase from "lodash/upperCase";
import { useRouter } from "next/router";
import { pluralizeString } from "helpers/string-format-helpers";
import { defaultLocation } from "data/defaultLocation";

function useInventoryTitle({ forMeta = false, count, noLocation }) {
  const router = useRouter();
  const year = getPathnameItem(router.query.slug, "year") ?? "";
  const formattedYear = year && !forMeta ? `${year} ` : "";
  const make = getPathnameItem(router.query.slug, "make") ?? "";
  const model = getPathnameItem(router.query.slug, "model") ?? "";
  const city =
    getPathnameItem(router.query.slug, "city") ?? defaultLocation.city;
  const province =
    getPathnameItem(router.query.slug, "province") ?? defaultLocation.province;
  let conditions = router.query.condition;
  if (!conditions || conditions.split(",").length > 1) {
    conditions = "New and used";
  }
  const formattedCar =
    [make, model].filter(Boolean).join(" ") || pluralizeString("cars", count);
  const locationOrStale =
    city && province ? ` in ${city}, ${upperCase(province)}` : "";
  const finalLocationString = city && province ? locationOrStale : "";
  const finalString = `${conditions} ${formattedYear}${formattedCar} for sale${
    noLocation ? " in " : finalLocationString
  }`;
  const returnString = forMeta ? `${finalString} | VINN` : finalString;
  return returnString;
}

export default useInventoryTitle;
